<template>
  <div>
    <div class="input-container" :class="!valid && 'invalid'">
      <div class="label-container px-3">
        <font-awesome-icon
          icon="fa-light fa-calendar-days"
          class="mr-2"
          v-if="type === 'datepicker' || type === 'monthpicker'"
        />
        <span>{{ label }}</span>
      </div>
      <el-input
        type="text"
        :class="button ? 'input-inner-with-button' : 'input-inner'"
        :maxlength="maxLength"
        v-model="content"
        :disabled="disabled"
        @input="handleInput"
        v-if="type === 'text'"
      />
      <el-date-picker
        v-model="content"
        type="date"
        placeholder=""
        prefix-icon="none"
        :disabled="disabled"
        @change="handleInput"
        :class="button ? 'input-inner-with-button' : 'input-inner'"
        v-else-if="type === 'datepicker'"
      />
      <el-date-picker
        v-model="content"
        type="month"
        placeholder=""
        prefix-icon="none"
        :disabled="disabled"
        @change="handleInput"
        :format="format"
        :value-format="valueFormat"
        :class="button ? 'input-inner-with-button' : 'input-inner'"
        v-else-if="type === 'monthpicker'"
      />
      <el-select
        v-model="content"
        placeholder=""
        clearable
        filterable
        :disabled="disabled"
        :class="button ? 'input-inner-with-button' : 'input-inner'"
        @change="handleInput"
        v-else-if="type === 'dropdown'"
      >
        <el-option
          v-for="(item, index) in items"
          :key="`select-${name}-${item.label || item}-${index}`"
          :label="item.label || item"
          :value="typeof item === 'object' ? item.value : item"
        >
        </el-option>
      </el-select>
      <div
        class="button-container px-3"
        @click="$emit('onClick')"
        v-if="button"
      >
        <font-awesome-icon icon="fa-regular fa-magnifying-glass" />
      </div>
    </div>
    <span class="error-label mt-1 ml-3">
      {{ errorLabel }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'Input',
  props: {
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'dropdown', 'datepicker', 'monthpicker'].includes(value),
    },
    field: {
      type: [String, Number, Date, Boolean],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: '',
    },
    valueFormat: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    button: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true,
    },
    errorLabel: {
      type: String,
      default: '',
    },
    maxLength: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: this.field,
    };
  },
  watch: {
    field() {
      this.content = this.field;
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content);
    },
  },
};
</script>
<style lang="scss" scoped>
.input-container {
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  border: 1px solid var(--input-border);

  &.invalid {
    border: 2px solid red;
    margin: -2px;

    & + .error-label {
      display: flex;
      color: red;
      font-size: 0.875rem;
    }
  }

  & + .error-label {
    display: none;
  }

  .label-container {
    background-color: var(--input-background);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-right: 1px solid var(--primary-secondary);
    display: flex;
    align-items: center;
    white-space: nowrap;
    min-width: var(--input-label-width);
    flex-shrink: 0;

    font-size: 13px;
    color: var(--primary-secondary);
    text-transform: uppercase;

    svg {
      font-size: 16px;
    }
  }

  .input-inner {
    width: 100%;

    ::v-deep .el-input__inner {
      border: none;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      height: 46px;
      padding: 0px 15px;
      background-color: var(--input-background);
    }
  }

  .input-inner-with-button {
    width: 100%;

    ::v-deep .el-input__inner {
      border: none;
      border-radius: 0px;
      height: 46px;
      padding: 0px 15px;
      background-color: var(--input-background);
    }
  }

  .button-container {
    background: var(--primary-secondary);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    display: flex;
    align-items: center;
    color: white;
    font-size: 18px;
    cursor: pointer;
  }
}
</style>
